var React = require('react')
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import './horizontal.css'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

class Menu extends React.Component {
	render() {
		const { children, pages, fileTypes, className, limit, shuffle, tag } = this.props
		let sliceEnd

		let pagesCopy = pages.slice()

		if (shuffle) {
			pagesCopy.sort((a,b) => {
				const rn = Math.floor(Math.random() * (3)) + -1;
				return rn;
			})
		}

		if (typeof limit !== 'number') {
			sliceEnd = pagesCopy.length
		} else {
			sliceEnd = limit + 2
		}

		const pageLinks = pagesCopy.splice( 0, sliceEnd ).map((page) => {
			if (fileTypes.indexOf(page.file.ext) !== -1) {
				return children(page)
			}
		})

		if (tag === 'ul') {
			return (
				<ul className={`menu ${className}`}>
					{pageLinks}
				</ul>
			)
		} else {
			return (
					<ReactCSSTransitionGroup
						component="div"
						className={`menu ${className}`}
	          transitionName="example"
	          transitionEnterTimeout={500}
	          transitionLeaveTimeout={300}>
						{pageLinks}
					</ReactCSSTransitionGroup>
			)
		}
	}
}

Menu.propTypes = {
	pages: React.PropTypes.array.isRequired,
	fileTypes: React.PropTypes.array.isRequired,
	className: React.PropTypes.string,
	limit: React.PropTypes.number,
	shuffle: React.PropTypes.bool,
	tag: React.PropTypes.oneOf(['div', 'ul'])
}

Menu.defaultProps = {
	pages: [],
	fileTypes: ['md'],
	className: '',
	shuffle: true,
	tag: 'div'
}

export default Menu


// WEBPACK FOOTER //
// ../components/ComponentMenu/index.js